import React from 'react';
import { Tooltip } from '@fluentui/react-components';
import { splitWorkspaceModuleLabels } from '../NewProjectFlow/accessGroupCatalog';
import styles from './css/index.module.css';

function ModuleTooltipContent({ labels }) {
    if (!labels?.length) {
        return <span>No modules</span>;
    }
    return (
        <div className={styles.moduleTooltip} style={{ color: '#fff' }}>
            <p className={styles.moduleTooltipTitle}>Workspace modules</p>
            <ul className={styles.moduleTooltipList}>
                {labels.map(label => (
                    <li key={label}>{label}</li>
                ))}
            </ul>
        </div>
    );
}

export default function FeatureModuleSummary({ featureKeys, emptyLabel = 'None selected' }) {
    const { primary, rest, all } = splitWorkspaceModuleLabels(featureKeys);

    if (!all.length) {
        return <p className={styles.chipEmpty}>{emptyLabel}</p>;
    }

    const inline = primary.join(' · ');
    const hiddenCount = rest.length;

    return (
        <p className={styles.moduleSummary}>
            {inline ? <span>{inline}</span> : null}
            {hiddenCount > 0 ? (
                <>
                    {inline ? ' ' : null}
                    <Tooltip
                        appearance="inverted"
                        positioning="above"
                        withArrow
                        relationship="description"
                        content={<ModuleTooltipContent labels={all} />}
                    >
                        <span className={styles.moduleMore} tabIndex={0} role="button" title={all.join(', ')}>
                            +{hiddenCount} more
                        </span>
                    </Tooltip>
                </>
            ) : null}
        </p>
    );
}
